import { DetailAction } from '@hp/ui';
import { useNavigate } from 'react-router';
import type { PipelineActiveRun } from './queries';
import { Spinner } from '../../components/ui/icons';
import { usePipelineText } from './messages';

// --- b) Active run strip ---

export function ActiveRunStrip({ run }: { run: PipelineActiveRun }) {
  const { t, text } = usePipelineText();
  const navigate = useNavigate();
  const progress = text(run.progressMsg, run.progress ?? '');
  const target =
    run.type === 'merge' ? `/crm-data/jobs/${run.id}` : run.type === 'publish' ? '/crm-data/enrichment#publish' : null;
  return (
    <div className="bo-active-run" role="status">
      <Spinner>
        <strong>{text(run.labelMsg, run.label)}</strong>
      </Spinner>
      {progress && <span className="bo-mono bo-muted">{progress}</span>}
      {target && (
        <DetailAction
          className="bo-grow-end"
          label={run.type === 'merge' ? t('activeRun.viewJob') : t('activeRun.viewPublish')}
          text
          onClick={() => void navigate(target)}
        />
      )}
    </div>
  );
}
